import {
	ADD_DATA,
	GET_ALL_DATA,
	UPDATE_DATA,
	DELETE_DATA,
} from "@/api/master/question";
import querystring from "query-string";

const state = {
	list: [],
	detail: {},
};

const mutations = {
	SET_LIST: (state, payload) => {
		state.list = payload;
	},
	// UPDATE_DATA(args) {
	// 	state.list.forEach((data, i) => {
	// 		if (data.id == args.id) {
	// 			console.log(args)
	// 			state.list[i] = JSON.stringify(JSON.parse(args));
	// 		}
	// 	})
	// }
};

const actions = {
	GET_LIST: async ({ commit }, params) => {
		params = querystring.stringify(params);
		const resp = await GET_ALL_DATA(params);
		const data = resp.data.data;
		commit("SET_LIST", data);
	},

	CREATE_DATA: async ({ commit }, args) => {
		return await ADD_DATA(args);
	},
	UPDATE_DATA: async ({ }, args) => {
		return await UPDATE_DATA(args);
	},
	DELETE_DATA: async ({ }, id) => {
		return await DELETE_DATA(id);
	},
	// CREATE_DATA: async ({ commit }, args) => {
	// 	var id = state.list.length + 1
	// 	args.id = id
	// 	state.list.push(args)
	// 	return await ADD_DATA(args);
	// },
	// UPDATE_DATA: async ({ commit }, args) => {
	// 	state.list.forEach(item => {
	// 		if (item.id == args.id) {
	// 			// console.log(args)
	// 			commit("UPDATE_DATA", args)
	// 		}
	// 	})
	// 	// return await UPDATE_DATA(args);
	// },

	// DELETE_DATA: async ({ }, id) => {
	// 	state.list.forEach((data, i) => {
	// 		if (data.id == id) {
	// 			state.list.splice(i, 1);
	// 		}
	// 	})
	// 	// return await DELETE_DATA(id);
	// },
};

const getters = {
	list: (state) => state.list,
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters,
};
